import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class NationalitySchemaDataModel extends BaseSchemaDataModel {}

export class NationalitySchemaModel extends BaseSchemaModel {
  model: NationalitySchemaDataModel;

  constructor(model: NationalitySchemaModel) {
    super(SCHEMA_TYPE.nationality, model.name);
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : `` ;
  }

  toString(): String {
    return `${this.typeParams}${this.nameParams}`;
  }
}
